import * as Sentry from "@sentry/nextjs";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import path from "constants/path";
import { getPaperDetails, PaperDetails } from "helpers/api";
import { getPaperDetailsEndpointParams } from "helpers/endpointQueryParams";
import { useRouter } from "next/router";

function usePaperDetails(id: string, initialData?: PaperDetails) {
  const router = useRouter();
  const queryParams = getPaperDetailsEndpointParams(router.query);

  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: ["paper_details", id],
    queryFn: async () => {
      const paper = await getPaperDetails(id, undefined, queryParams);
      return paper;
    },
    enabled: !initialData,
    initialData: initialData,
    onError: (error: unknown) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 404) {
          // Set data to null if paper was not found
          return null;
        } else if (error.response?.status === 429) {
          router.push(path.TOO_MANY_REQUESTS);
        } else {
          router.push(path.INTERNAL_SERVER_ERROR);
        }
      }

      Sentry.captureException(error, {
        data: { id, initialData, queryParams },
      });
    },
  });

  return { data, isLoading, isFetching, error };
}

export default usePaperDetails;
